import type { ItemStatus } from '@/common/api/types/itemStatus';
import { ItemStatusBadge } from '@/common/components/ui/itemStatusBadge';
import type { ItemsTableRow } from '@/features/items/components/table/types';

export const StatusCell = ({
  row,
  itemStatuses,
}: {
  row: ItemsTableRow;
  itemStatuses: ItemStatus[];
}) => {
  const itemStatus = itemStatuses.find((status) => status.id === row.itemStatusId);
  if (!itemStatus) {
    return null;
  }
  return <ItemStatusBadge color={itemStatus.color} label={itemStatus.name} />;
};
